const lang = {
    "Kep": "QES",
    "KepNotLinked": "hyväksyttyä allekirjoitustasi ei ole vielä liitetty tiliin. Kirjaudu tavalliseen tapaan, niin liitämme sen.",
    "KepNewAccount": "Eikö sinulla ole tiliä? Rekisteröidy",
    "KepLinked": "Hyväksytty allekirjoitus liitetty tiliin",
    "KepLinkFailed": "Hyväksytyn allekirjoituksen liittäminen epäonnistui. Kirjaudu sillä uudelleen, niin liitämme sen",
    "KepFile": "Avaintiedosto",
    "ErrorKepLogin": "Kirjautuminen hyväksytyllä allekirjoituksella epäonnistui",
    "EnterWidth": "Kirjaudu sisään:",
    "Registration": "Rekisteröidy",
    "enter": "Tulla sisään",
    "EntrWidthEmailOrPhone": "Kirjaudu sisään sähköpostitse tai puhelimitse",
    "login": "Valtuutus",
    "NoAkkGoReg": "Rekisteröidy",
    "Password": "Salasana",
    "Name": "Nimi",
    "LastName": "Sukunimi",
    "Phone": "Rekisteröityäksesi, anna puhelinnumerosi",
    "Email": "Mail",
    "RepeatPassword": "Toista salasana",
    "Сancel": "Peruuttaa",
    "Save": "Tallentaa",
    "Language": "Kieli",
    "ConfirmThisMail": "Sähköpostisi on vahvistettu",
    "Saved": "Tallennettu",
    "Error": "Virhe",
    "FillInAllTheFields": "Täytä kaikki kentät",
    "Next": "Edelleen",
    "MinPassLength": "Salasanan minimipituus 4 merkkiä",
    "ForgotYourPassword": "Unohditko salasanasi",
    "RestorePassword": "Aseta uusi salasana.",
    "UserMustBeRegistered": "Käyttäjän tulee olla rekisteröitynyt",
    "Confirm": "Vahvistaa",
    "WrongFormat": "Väärä formaatti",
    "WrongPassword": "Väärä salasana",
    "WrongLoginOrPassword": "väärä kirjautumistunnus tai salasana",
    "PhoneAlreadyRegistered": "Puhelin on jo rekisteröity",
    "EmailAlreadyRegistered": "Posti on jo rekisteröity",
    "FillInTheFieldsCorrectly": "Täytä kentät oikein",
    "ThisAccountDoesNotExist": "tätä käyttäjää ei ole olemassa",
    "LinkIsNotValid": "Linkki ei kelpaa",
    "AMessageHasBeenSentToTheSpecifiedLogin": "Viesti on lähetetty määritettyyn käyttäjätunnukseen",
    "IncorrectCaptcha": "Väärä captcha",
    "CaptchaIsNotValid": "Captcha ei ole enää voimassa",
    "EnterCaptcha": "Kirjoita captcha",
    "EnterSMS": "Syötä koodi tekstiviestistä",
    "SMSCodeIsNoLongerValid": "SMS-koodi ei ole enää voimassa",
    "SMSCodeIsIncorrect": "SMS-koodi on väärä",
    "MailNotVerifiedLinkTimedOut": "Postia ei vahvistettu, linkki vanhentunut",
    "DemoLogin": "Demo kirjautuminen",
    "AreYouSureYouWantToEnterTheDemoForEvaluation": "Haluatko varmasti osallistua <b> demoon </b> kokeillaksesi sitä?",
    "FillInAdditionalInformation": "Täytä lisätiedot",
    "ToCompleteRegistration": "Viimeistele rekisteröinti",
    "LinkThirdPartyServices": "Linkitä kolmannen osapuolen palvelut",
    "Complete": "Saada valmiiksi",
    "AccountAlreadyLinked": "Tili on jo linkitetty",
    "AccountNotRegistered": "Tiliä ei ole rekisteröity",
    "NotMyNumber": "Ei minun numeroni",
    "Back": "Takaisin",
    "numberOfAttemptsToCheckAuth": "Kirjautumisyritysten määrä:",
    "InvalidPassNumberOfAttemptsToCheckAuth": "Väärä salasana, kirjautumisyritysten määrä:",
    "TryAgainAfterMinute": "Yritä uudelleen kahden minuutin kuluttua",
    "Help": "Tuki",
    "y": "Joo",
    "n": "Ei",
    "doYouConfirmEmail": "Haluatko varmasti vaihtaa sähköpostiosoitteesi?",
    "success": "Onnistuneesti",
    "goToAutorize": "Siirry valtuutukseen",
    "UserEmailAlreadyExists": "Käyttäjä, jolla on tämä sähköpostiosoite, on jo olemassa",
    "UserPhoneAlreadyExists": "Käyttäjä tällä puhelinnumerolla on jo olemassa",
    "TermOfUse": "Käyttöehdot",
    "PrivacyPolicy": "Tietosuojakäytäntö",
    "accountNotRegistered": "tiliä ei ole rekisteröity",
    "wantToReg": "Haluatko rekisteröityä?",
    "weSuccessChangeYouEmail": "Olemme vaihtaneet sähköpostiosoitteesi onnistuneesti",
    "youCanCloseThisWindow": "Voit sulkea tämän ikkunan",
    "countryConfirm": "Maan vahvistus",
    "EmailAlreadyTied": "Mail on jo linkitetty toiseen tiliin",
    "areYourCountry": "onko tämä sinun maasi?",
    "EmergencyEntrance": "Vanha valtuutus",
    "enterCorrectNumber": "Syötä numero kansainvälisessä muodossa",
    "thisPhoneRegister": "Tämä puhelinnumero on jo rekisteröity järjestelmään",
    "wantUsePhoneForAuth": "Haluatko kirjautua sisään tällä puhelinnumerolla?",
    "ok": "ok",
    "regAgree": "Rekisteröimällä tilin hyväksyn",
    "wantBind": "Haluatko kirjautua sisään ja linkittää palveluun",
    "bind": "sitoa",
    "yoursMailBinded": "Sähköpostisi on olemassa olevalla tilillä",
    "wantUsePhoneAndBind": "jo rekisteröity järjestelmään",
    "notGetDataFromApple": "Tietojen vastaanottaminen Applelta epäonnistui",
    "ErrorAppleLogin": "Virhe valtuutuksessa Applen kautta",
    "ErrorGoogleLogin": "Virhe valtuutettaessa Googlen kautta",
    "ErrorTelegramLogin": "Virhe kirjautuessasi sisään Telegramin kautta",
    "ErrorFacebookLogin": "Virhe kirjautumisessa Facebookin kautta",
    "EMailOrPhone": "Anna kelvollinen puhelinnumero tai sähköpostiosoite.",
    "withoutName": "Ei nimeä",
    "goToCabinet": "Toimistolle",
    "Logout": "Lopeta istunto",
    "creationDate": "Luomispäivämäärä",
    "preparingCompany1": "Luomme yritystäsi, anna meille hetki...",
    "preparingCompany2": "Valmistelemme käyttöliittymää tavaroiden ja palveluiden hallintaan...",
    "preparingCompany3": "Työskentelemme kätevän taloushallinnon parissa...",
    "preparingCompany4": "Teemme lopullisia asetuksia, melkein valmiina...",
    "companyBlocked": "Tämä yritys ei ole aktiivinen",
    "youBlockedInComp": "Käyttäjä ei ole aktiivinen, kirjautuminen ei ole mahdollista",
    "loginTitle": "Kaikki mitä yritys tarvitsee yhdessä paikassa",
    "loginDescr": "Automaatiota kaupoille, kahviloille, toimituspalveluille, ravintoloille, varastoille, tuotannolle tai palveluille",
    "NoAkkGoRegText": "Eikö sinulla ole tiliä?",
    "LoginPlaceholder": "Anna tarvittavat tiedot",
    "loginText": "Onko sinulla jo tili?",
    "and": "Ja",
    "AcceptTheTerms": "Hyväksy tietosuojakäytäntö ja käyttöehdot",
    "CountryPhoneFormat": "Jos tämä ei ole maasi, tarkista, että olet antanut puhelinnumerosi oikeassa kansainvälisessä muodossa.",
    "SaveNewPassword": "Tallenna uusi salasana"
}

export default function() {
    return lang;
}